import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import styles from './menu-item-icon.styles.scss';

export const MENU_ITEM_ICON_TAG = 'spog-common-menu-item-icon' as const;

/**
 * Icon component used to style SVG icons within
 * menu items.
 */
@customElement(MENU_ITEM_ICON_TAG)
export class SpogMenuItemIcon extends LitElement {
  static override styles = [styles];
  override render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [MENU_ITEM_ICON_TAG]: SpogMenuItemIcon;
  }
}
